module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Buttons\n      "), _c('small', [_vm._v("Control panel")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("UI")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Buttons")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Buttons")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body pad table-responsive"
  }, [_c('p', [_vm._v("Various types of buttons. Using the base class "), _c('code', [_vm._v(".btn")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered text-center"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Normal")]), _vm._v(" "), _c('th', [_vm._v("Large "), _c('code', [_vm._v(".btn-lg")])]), _vm._v(" "), _c('th', [_vm._v("Small "), _c('code', [_vm._v(".btn-sm")])]), _vm._v(" "), _c('th', [_vm._v("X-Small "), _c('code', [_vm._v(".btn-xs")])]), _vm._v(" "), _c('th', [_vm._v("Flat "), _c('code', [_vm._v(".btn-flat")])]), _vm._v(" "), _c('th', [_vm._v("Disabled "), _c('code', [_vm._v(".disabled")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "btn btn-block btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Default")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-default btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Default")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-default btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Default")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-default btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Default")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-default btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Default")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-default disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Default")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-primary btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-primary btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-primary btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-primary btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-primary disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Primary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-success btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-success btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-success btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-success btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-success disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Success")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "btn btn-block btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-info btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-info btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-info btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-info btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-info disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Info")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "btn btn-block btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-danger btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-danger btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-danger btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-danger btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-danger disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Danger")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "btn btn-block btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-warning btn-lg",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-warning btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-warning btn-xs",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-warning btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-warning disabled",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Warning")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Block Buttons")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn-block")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn-block .btn-flat")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block btn-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn-block .btn-sm")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Horizontal Button Group")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body table-responsive pad"
  }, [_c('p', [_vm._v("\n              Horizontal button groups are easy to create with bootstrap. Just add your buttons\n              inside "), _c('code', [_vm._v("<div class=\"btn-group\"></div>")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Button")]), _vm._v(" "), _c('th', [_vm._v("Icons")]), _vm._v(" "), _c('th', [_vm._v("Flat")]), _vm._v(" "), _c('th', [_vm._v("Dropdown")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Right")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Right")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-info btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-info dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Right")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Right")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-warning dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Right")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Button Addon")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_vm._v("With dropdown")]), _vm._v(" "), _c('div', {
    staticClass: "input-group margin"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Action\n                  "), _c('span', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Normal")]), _vm._v(" "), _c('div', {
    staticClass: "input-group margin"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Flat")]), _vm._v(" "), _c('div', {
    staticClass: "input-group margin"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-info btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Go!")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Split buttons")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_vm._v("Normal split buttons:")]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])])]), _vm._v(" "), _c('p', [_vm._v("Flat split buttons:")]), _vm._v(" "), _c('div', {
    staticClass: "margin"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-info btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-flat dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-flat dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-flat dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-flat dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Social Buttons (By "), _c('a', {
    attrs: {
      "href": "https://github.com/lipis/bootstrap-social"
    }
  }, [_vm._v("Lipis")]), _vm._v(")\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('a', {
    staticClass: "btn btn-block btn-social btn-bitbucket"
  }, [_c('i', {
    staticClass: "fa fa-bitbucket"
  }), _vm._v(" Sign in with Bitbucket\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-dropbox"
  }, [_c('i', {
    staticClass: "fa fa-dropbox"
  }), _vm._v(" Sign in with Dropbox\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-facebook"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" Sign in with Facebook\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-flickr"
  }, [_c('i', {
    staticClass: "fa fa-flickr"
  }), _vm._v(" Sign in with Flickr\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-foursquare"
  }, [_c('i', {
    staticClass: "fa fa-foursquare"
  }), _vm._v(" Sign in with Foursquare\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-github"
  }, [_c('i', {
    staticClass: "fa fa-github"
  }), _vm._v(" Sign in with GitHub\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-google"
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  }), _vm._v(" Sign in with Google\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-instagram"
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  }), _vm._v(" Sign in with Instagram\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-linkedin"
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  }), _vm._v(" Sign in with LinkedIn\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-tumblr"
  }, [_c('i', {
    staticClass: "fa fa-tumblr"
  }), _vm._v(" Sign in with Tumblr\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-twitter"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  }), _vm._v(" Sign in with Twitter\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-social btn-vk"
  }, [_c('i', {
    staticClass: "fa fa-vk"
  }), _vm._v(" Sign in with VK\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-social-icon btn-bitbucket"
  }, [_c('i', {
    staticClass: "fa fa-bitbucket"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-social-icon btn-dropbox"
  }, [_c('i', {
    staticClass: "fa fa-dropbox"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-social-icon btn-facebook"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-social-icon btn-flickr"
  }, [_c('i', {
    staticClass: "fa fa-flickr"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-social-icon btn-foursquare"
  }, [_c('i', {
    staticClass: "fa fa-foursquare"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-social-icon btn-github"
  }, [_c('i', {
    staticClass: "fa fa-github"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-social-icon btn-google"
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-social-icon btn-instagram"
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-social-icon btn-linkedin"
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-social-icon btn-tumblr"
  }, [_c('i', {
    staticClass: "fa fa-tumblr"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-social-icon btn-twitter"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-social-icon btn-vk"
  }, [_c('i', {
    staticClass: "fa fa-vk"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Application Buttons")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_vm._v("Add the classes "), _c('code', [_vm._v(".btn.btn-app")]), _vm._v(" to an "), _c('code', [_vm._v("<a>")]), _vm._v(" tag to achieve the following:")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edit\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app"
  }, [_c('i', {
    staticClass: "fa fa-play"
  }), _vm._v(" Play\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app"
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  }), _vm._v(" Repeat\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app"
  }, [_c('i', {
    staticClass: "fa fa-pause"
  }), _vm._v(" Pause\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app"
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app"
  }, [_c('span', {
    staticClass: "badge bg-yellow"
  }, [_vm._v("3")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" Notifications\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app"
  }, [_c('span', {
    staticClass: "badge bg-green"
  }, [_vm._v("300")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-barcode"
  }), _vm._v(" Products\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app"
  }, [_c('span', {
    staticClass: "badge bg-purple"
  }, [_vm._v("891")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Users\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app"
  }, [_c('span', {
    staticClass: "badge bg-teal"
  }, [_vm._v("67")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-inbox"
  }), _vm._v(" Orders\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app"
  }, [_c('span', {
    staticClass: "badge bg-aqua"
  }, [_vm._v("12")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Inbox\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-app"
  }, [_c('span', {
    staticClass: "badge bg-red"
  }, [_vm._v("531")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-heart-o"
  }), _vm._v(" Likes\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Different colors")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_vm._v("Mix and match with various background colors. Use base class "), _c('code', [_vm._v(".btn")]), _vm._v(" and add any available\n              "), _c('code', [_vm._v(".bg-*")]), _vm._v(" class")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn bg-maroon btn-flat margin",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn.bg-maroon.btn-flat")]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-purple btn-flat margin",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn.bg-purple.btn-flat")]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-navy btn-flat margin",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn.bg-navy.btn-flat")]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-orange btn-flat margin",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn.bg-orange.btn-flat")]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-olive btn-flat margin",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn.bg-olive.btn-flat")])]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn bg-maroon margin",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn.bg-maroon")]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-purple margin",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn.bg-purple")]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-navy margin",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn.bg-navy")]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-orange margin",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn.bg-orange")]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-olive margin",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(".btn.bg-olive")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Vertical Button Group")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body table-responsive pad"
  }, [_c('p', [_vm._v("\n              Vertical button groups are easy to create with bootstrap. Just add your buttons\n              inside "), _c('code', [_vm._v("<div class=\"btn-group-vertical\"></div>")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Button")]), _vm._v(" "), _c('th', [_vm._v("Icons")]), _vm._v(" "), _c('th', [_vm._v("Flat")]), _vm._v(" "), _c('th', [_vm._v("Dropdown")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Top")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Bottom")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Top")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Bottom")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-info btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-info dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Top")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Bottom")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Top")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Bottom")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-warning dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Top")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Middle")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Bottom")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "btn-group-vertical"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dropdown link")])])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b56adee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ui/Buttons.vue
// module id = 1893
// module chunks = 1